import type { PlayerState } from "../../model/PlayerState.js";
import type { Board } from "../../model/Board.js";
import type { PlayerType } from "../../model/PlayerType.js";
import type {
    DescribePlayerNames } from "./GameState.js";
import {
    getDescribePlayerName,
} from "./GameState.js";
import { ControlGameState } from "./ControlGameState.js";
import { isSameRuntimeType } from "../../../util/tsutils.js";


/**
 * A game state that represents a player resigning from a game.
 */
export class ResignedGameState extends ControlGameState {
    constructor(
        board: Board,
        lightPlayer: PlayerState,
        darkPlayer: PlayerState,
        timeSinceGameStartMs: number,
        player: PlayerType,
    ) {
        super(board, lightPlayer, darkPlayer, timeSinceGameStartMs, player);
    }

    override describe(playerNames?: DescribePlayerNames): string {
        const playerName = getDescribePlayerName(this.getPlayer(), playerNames);
        return `${playerName} resigned`;
    }

    override equals(other: unknown): boolean {
        if (other === this)
            return true;
        if (!isSameRuntimeType(this, other))
            return false;

        return ControlGameState._baselineEquals(this, other);
    }
}
